export default (remoteUser, currentUserSocketId) => {
    if (!remoteUser || !currentUserSocketId) {
        return false;
    }

    return remoteUser.socketId !== currentUserSocketId;
};
